// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4300":"3a37384f","8451":"cc81a737","9583":"3a37384f"}[chunkId] + ".chunk.css";
};